import {ReactNode, useEffect, useLayoutEffect, useState} from 'react';

import {BrowserHistory} from 'history';
import {Router} from 'react-router-dom';

interface CustomRouterProps {
  children: ReactNode;
  history: BrowserHistory;
}

export const CustomRouter = ({children, history}: CustomRouterProps) => {
  const [{action, location}, setRouterState] = useState({action: history.action, location: history.location});

  useLayoutEffect(() => history.listen(setRouterState), [history]);

  /* Only needed for localhost and amplify on logout
     If '/customers' is not in url, children of Router will not render
     Redirect prevents blank screen on logout
  */
  useEffect(() => {
    if (!history.location.pathname.includes('/customers')) {
      history.replace({...history.location, pathname: `/customers${history.location.pathname}`});
    }
  }, [history]);

  return (
    <Router basename="/customers" navigator={history} navigationType={action} {...{location}}>
      {children}
    </Router>
  );
};
